import React from 'react';
import { Route } from 'react-router-dom';
import ListLiquidaciones from './Components/ListLiquidaciones';
import LiquidacionNew from './Components/LiquidacionNew';
import EditarLiquidacion from './Components/EditarLiquidacion';
import EditarLiquidacionBorrador from './Components/EditarLiquidacionBorrador';
import ActualizacionMasivaLiquidaciones from "./Components/Excel/ActualizacionMasivaLiquidaciones";

export default class AdmLiquidaciones extends React.Component {
  render() {
    return (
      <div>
        <Route exact path="/Liquidaciones" component={ListLiquidaciones} />
        <Route exact path="/Liquidaciones/Nueva" component={LiquidacionNew} />
        <Route exact path="/Liquidaciones/Editar/:id/:idSeller" component={EditarLiquidacion} />
        <Route exact path="/Liquidaciones/EditarBorrador/:id/:idSeller" component={EditarLiquidacionBorrador} />
        <Route exact path="/Liquidaciones/ActualizacionMasiva" component={ActualizacionMasivaLiquidaciones}/>
      </div>
    );
  }
}